<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col sm="12">
      <transition name="slide">
      <b-card>
        <div slot="header">
          <div class="row pl-2 pr-2">
            <b-col sm="12" lg="9" class=" p-1 title">
              <span>Corporações</span>
            </b-col>
            <b-col sm="12" lg="2" class="input-group input-group-sm p-1">
              <input class="form-control input-txt" id="txt-search" type="text" name="txt-search" v-model="searchValue" v-on:keyup.enter="search">
              <span class="input-group-append">
                <button id="btn-search" class="btn btn-success" type="button" @click="search" @click.stop.prevent><i class="fa fa-search"></i></button>
              </span>
            </b-col>
            <b-col sm="12" lg="1" class=" p-1">
              <b-button type="button" size="sm" variant="success" class="btn-novo form-control" @click="corporationNew">Novo</b-button>
            </b-col>
          </div>
        </div>
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" @row-clicked="rowClicked">
          <template slot="id" slot-scope="data">
            <strong>{{data.item.id}}</strong>
          </template>
          <template slot="status" slot-scope="data">
            <b-badge :variant="getBadge(data.item)">{{status[data.item.status]}}</b-badge>&nbsp;
            <b-badge v-if="data.item.isUsersFull" variant="warning" title="Quantidade máxima de usuários atingida">Cheio</b-badge>
          </template>
          <template slot="managementUserType" slot-scope="data">
            {{management[data.item.managementUserType]}}
          </template>
          <template slot="licenseType" slot-scope="data">
            {{license[data.item.licenseType]}}
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @change="paginationChanged" prev-text="<<" next-text=">>" hide-goto-end-buttons/>
        </nav>
      </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env } from '@/shared/utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Corporations',
  components: {
    Loading
  },
  props: {
    caption: {
      type: String,
      default: 'Corporações'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      fields: [
        {key: 'name', label: 'Nome'},
        {key: 'cnpj', label: 'CNPJ'},
        {key: 'managementUserType', label: 'Gerenciamento'},
        {key: 'licenseType', label: 'Licença'},
        {key: 'status'}
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      status: {
        0: "Ativo",
        1: "Desativado",
        2: "Bloqueado"
      },
      management: {
        "permissive": "Permissivo",
        "restrictive": "Restritivo"
      },
      license: {
        "withoutReplacement": "Sem substituição",
        "activeUser": "Usuário ativo",
        "bySeat": "Por assento"
      },
      itemsByPage: {},
      searchValue: "",
      loadCount: 0,
    }
  },
  mounted() {
    this.getCorporations();
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    getBadge (item) {
      switch (item.status) {
        case 1:
          return 'danger'
        default:
          return 'success'
      }
    },
    rowClicked (item) {
      if (JSON.parse(localStorage.roles).includes('corporation_manager')) {
        this.$router.push({path: `corporations/edit/${item.id}`})
      } else {
        this.$router.push({path: `corporations/view/${item.id}`})
      }
    },
    corporationNew () {
      this.$router.push('corporations/new');
    },
    paginationChanged (pageNumber) {
      this.getCorporations(pageNumber, this.searchValue);
    },
    search () {
      this.getCorporations(1, this.searchValue);
    },
    getCorporations (page = 1, search = "") {
      var cacheKey = search + page;
      if (this.itemsByPage[cacheKey]) {
        this.items = this.itemsByPage[cacheKey];
        this.currentPage = page;
        return;
      }
      var _this = this;
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/corporation?page=${page}&search=${search}`)
        .then(function(response) {
          if (!response.data._embedded.corporation.length) {
            alert("Nenhuma corporação encontrada.");
            return;
          }
          _this.items = response.data._embedded.corporation;
          _this.currentPage = response.data.page;
          _this.itemsByPage[search + _this.currentPage] = _this.items;
          _this.perPage = response.data.page_size;
          _this.totalRows = response.data.total_items;
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    }
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.search-area {
  max-width: 280px;
}
.input-txt {
  height: 32px !important;
}
@media screen and (max-width: 468px) {
  .title {
    text-align: center;
  }
}
</style>
